<template>
  <div>
    <b-autocomplete
      expanded
      v-model="receiptSearchText"
      :data="receiptsList"
      placeholder="Buscar receita"
      field="name"
      :loading="isFetching"
      :keep-first="true"
      @keyup.native="getReceiptAsyncData"
      @select="setOrderReceipt"
    >
      <template slot-scope="props">
        <span>{{ props.option.name }}</span>
      </template>
      <template slot="empty">Nenhuma receita encontrada.</template>
    </b-autocomplete>
  </div>
</template>

<script>
import utils from "../../helpers/debounce";
import QueryBuilder from "../../helpers/QueryBuilder";
import ReceiptService from "../../services/ReceiptService";
export default {
  name: "AutocompleteReceipt",
  data: function() {
    return {
      receiptSearchText: "",
      receiptsList: [],
      selectedReceipt: {},
      isFetching: false
    };
  },
  props: ["item"],
  methods: {
    setOrderReceipt(value) {
      let orderReceipt = Object.assign({}, this.item);
      orderReceipt.receipt = value;
      this.$emit("setReceiptSelected", orderReceipt);
    },
    getReceiptAsyncData: utils.debounce(function() {
      this.receiptsList = [];
      let query = {
        name: this.receiptSearchText,
        size: 5
      };
      query = QueryBuilder.getQueryString(query);
      this.isFetching = true;
      ReceiptService.getReceipts(query)
        .then(({ data }) => {
          this.receiptsList = data.content;
        })
        .finally(() => (this.isFetching = false));
    }, 300)
  },
  created() {
    if(this.item.id){
      this.selectedReceipt = this.item.receipt;
      this.receiptSearchText = this.item.receipt.name;
    }
  }
};
</script>

<style scoped></style>
